<template>
  <div>
    <br/>
    <v-card tile>
      <v-toolbar card dark color="primary">
        <router-link v-if="$route.params.customerId" :to="{ name: 'BuyersInfo', params: { buyerId:$route.params.customerId }}">
          <v-btn icon dark @click="dialog = false">
            <v-icon>keyboard_backspace</v-icon>
          </v-btn>
          </router-link>
          <v-flex xs12 sm6 md2>
            <h3 class="font-weight-light headline">
              Statements
            </h3>
            <b class="font-weight-bold">{{this.currentUser.name}}</b>
          </v-flex>
          <v-flex xs12 sm6 md3>
            <v-select
              class="select-firm"
              dense
              item-text="name"
              return-object
              :items="firmsByBrand"
              label="Select Firm"
              v-model="selectedFirm"
              clearable
            ></v-select>
          </v-flex>
          
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerFrom"
              :nudge-right="40"
              class="ist-datepicker"
              lazy
              transition="scale-transition"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="fromDate"
                label="From Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="fromDate" @input="datepickerFrom = false"></v-date-picker>
            </v-menu>
          </v-flex>
          <v-flex xs12 sm3 md3>
            <v-menu
              :close-on-content-click="false"
              v-model="datepickerTo"
              :nudge-right="40"
              lazy
              transition="scale-transition"
              class="ist-datepicker"
              offset-y
              full-width
              min-width="290px"
            >
              <v-text-field
                slot="activator"
                v-model="toDate"
                label="To Date"
                prepend-icon="event"
                readonly
              ></v-text-field>
              <v-date-picker v-model="toDate" @input="datepickerTo = false"></v-date-picker>
            </v-menu>
          </v-flex>          
          <v-spacer/>
          <v-flex xs12 sm2 md2>
              <v-select
                dense
                v-model="voucherTypeFilter"
                multiple
                :items="[
                'Receipt',
                'Payment',
                'Credit Note',
                'Debit Note',
                'Asset',
                'Expense',
                'Liability',
                'Income',
                'Staff',
                'Transfer',
                'Advance',
                'LoanGiven',
                'LoanTaken',
                'Security',
                'Opening Balance',
                'Sale',
                'Purchase'
                ]"
              label="Filter Voucher Type"
              clearable
            >
            </v-select>
          </v-flex>  
          <!-- <v-flex xs12 sm6 md1>   -->
             <v-btn outline>
               <v-icon class="primary white--text" @click="print()">
                print
               </v-icon>
             </v-btn>
             <v-btn outline>
               <v-icon class="primary white--text" @click="printDetailed()">
                save_alt
               </v-icon>
             </v-btn>
             <!-- <v-btn outline>
               <v-icon class="primary white--text" @click="exportXLS()">
                save_alt
               </v-icon>
             </v-btn>    -->
          <!-- </v-flex> -->
        <!-- <v-spacer />
         <router-link  v-if="$route.params.customerId" :to="{ name: 'BuyersInfo', params: { buyerId: $route.params.customerId }}">
          <v-btn icon dark @click="dialog = false">
            <v-icon>close</v-icon>
          </v-btn>
          </router-link> -->
      </v-toolbar>
      <v-card-text>
        <h3>Previous Running Balance : {{prevRunningBal}}</h3>
        <v-data-table
          :headers="invoiceHeader"
          :items="invoiceList"
          class="elevation-1 dashboardHead"
        >
          <template slot="items" slot-scope="props">
            <template v-if="'isBuyer' in props.item || 'type' in props.item">
              <td>
                <v-icon v-if="props.item['type']!='CustomerPayment'" @click="openProd(props.item)" color="primary">remove_red_eye</v-icon>
              </td>
              <td>
                <!-- <b>{{new Date(props.item.date).toLocaleDateString('en-GB')}}</b> -->
                <b>{{new Date(props.item.closedDate ? props.item.closedDate : props.item.date).toLocaleDateString('en-GB')}}</b>
              </td>
              <!-- <td>
                <b>{{ props.item['.key']}}</b>
              </td> -->
              <!-- <td>
                <b>{{getFirmName(props.item.firm)}}</b>
              </td> -->
              <td>
                <b v-if="props.item['type']!='CustomerPayment'">{{ props.item['invoiceId']}}</b>
              </td>
              <td>
                <b class="green--text font-weight-bold">{{props.item['debit'] || 0 | amount }}</b>
              </td>
              <td>
                <b class="red--text font-weight-bold">{{props.item['credit'] || 0 | amount }}</b>
              </td>
              <td>
                <b class="primary--text font-weight-bold" v-if="isUserBuyer">{{props.item['RunningBal'] | amount }}</b>
                <b class="primary--text font-weight-bold" v-else>{{props.item['RunningBal'] | amount }}</b>
              </td>
              <td>
                <b>{{ props.item['paymentType']}}</b>
              </td>
              <td>
                <b>{{ getVocherType(props.item)}}</b>
              </td>
            </template>
          </template>
          <template slot="no-data">No Items</template>
          <template slot="footer">
            <tr>
              <td>
                  
              </td>
              <td>
                <b>Total</b>
              </td>
             
              <td>
                  
              </td>
              <td>
                <b class="green--text font-weight-bold">{{total['debit'] || 0 | amount }}</b>
              </td>
              <td>
                <b class="red--text font-weight-bold">{{total['credit'] || 0 | amount }}</b>
              </td>
              <td>
                <b class="primary--text font-weight-bold" v-if="isUserBuyer">{{total['RunningBal'] | amount }}</b>
                <b class="primary--text font-weight-bold" v-else>{{(total['RunningBal']) | amount }}</b>
              </td>
              <td>                
              </td>
              <td>
              </td>
            </tr>
          </template>
        </v-data-table>
      </v-card-text>
      <v-dialog v-model="dialog" width="800" v-if="selectedInvoice && selectedInvoice['.key']">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>
            <!-- {{selectedInvoice['.key']}} -->
            {{selectedInvoice.customer ? selectedInvoice.customer.name : ''}}
          </v-card-title>

          <v-card-text>
            <v-layout row wrap>
              <v-flex xs12 sm4 md4>
                <!-- <b>key :-</b>
                {{selectedInvoice['.key']}}
                <br /> -->
                <b>Name :-</b>
                {{selectedInvoice.customer ? selectedInvoice.customer.name : ''}}
                <br />
                <b>Firm :-</b>
                {{getFirmName(selectedInvoice.firm)}}
                <br />
                <b>Invoice Number :-</b>
                {{selectedInvoice['invoiceId']}}
                <br />
                <b>Payment Type :-</b>
                {{selectedInvoice['paymentType']}}
                <br />
                <b>Status :-</b>
                {{selectedInvoice['status']}}
                <br />
                <b>Duration (in Days) :-</b>
                {{selectedInvoice['duration']}}
                <br />
              </v-flex>

              <v-flex xs12 sm4 md4>
                <b class="font-weight-bold green--text">Total Amount :-</b>
                <b class="font-weight-bold green--text">₹.{{selectedInvoice['totalAmount']}}</b>
                <br />
                <b>Basic Amount :-</b>
                <b class="font-weight-bold blue--text">₹. {{selectedInvoice['totalAmount'] - getGSTtotal(selectedInvoice)}}</b>
                <br />
                <b>GST :-</b>
                ₹. {{getGSTtotal(selectedInvoice)}}
                <br />
                <b>Discount :-</b>
                ₹. {{selectedInvoice['discountAmount']}}
                <br />
                <b>Paid Amount :-</b>
                ₹. <b class="font-weight-bold primary--text">{{selectedInvoice['paidAmount']}}</b>
                <br />
                <b class="font-weight-bold red--text">Remaining Amount :-</b>
                <b class="font-weight-bold red--text">₹.{{selectedInvoice['remainingAmount']}}</b>
                <br />
              </v-flex>
              
              <v-flex xs12 sm4 md4>
                <!-- <b>Transaction Type :-</b>
                {{selectedInvoice['transactionType']}}
                <br /> -->
                <b>GST Type :-</b>
                {{selectedInvoice['gstType']}}
                <br />
                <b>GST (0%) :-</b>
                ₹. {{selectedInvoice['GST_Percentage_total']['GST_3']}}
                <br />
                <b>GST (5%) :-</b>
                ₹. {{selectedInvoice['GST_Percentage_total']['GST_5']}}
                <br />
                <b>GST (12%) :-</b>
                ₹. {{selectedInvoice['GST_Percentage_total']['GST_12']}}
                <br />
                <b>GST (18%) :-</b>
                ₹. {{selectedInvoice['GST_Percentage_total']['GST_18']}}
                <br />
                <b>GST (28%) :-</b>
                ₹. {{selectedInvoice['GST_Percentage_total']['GST_28']}}
                <br />
              </v-flex>
            </v-layout>
            <br/>
            <v-data-table
              :headers="invoiceProductListHeader"
              :items="selectedInvoice.items"
              class="elevation-1 dashboardHead"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <b>{{ props.item['productName']}}</b>
                </td>
                <td>
                  <b>{{ props.item['HSN_code']}}</b>
                </td>
                <td>
                  <b>{{ props.item.taxableGST_rate}}</b>
                </td>
                <td>
                  <b>{{ props.item['productUnit']}}</b>
                </td>
                <td>
                  <b>{{ props.item['quantity']}}</b>
                </td>
                <td>
                  <b>{{ props.item['fat']}}</b>
                </td>
                <td>
                  <b>{{ props.item['rate']}}</b>
                </td>
              </template>
              <template slot="no-data">No Items</template>
            </v-data-table>
          </v-card-text>

          <v-divider></v-divider>

          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="dialog = false">Close</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <div style="flex: 1 1 auto;"></div>
    </v-card>
  </div>
</template>
<script>
import { createNamespacedHelpers } from "vuex";
import { getGSTPercentageTotal } from "../../../utils";
import { buyerStatement } from "../../../utils/pdfmake";
import { buyerStatementDetailed } from "../../../utils/pdfmake";
import { buyerStatementExcel } from "../../../utils/excelExport";
import XLSX from 'xlsx';

const mapGlobalGetters = createNamespacedHelpers("Global")["mapGetters"];
const mapBuyerGetters = createNamespacedHelpers("Buyer")["mapGetters"];

export default {
  name: "BuyerTransactionStatements",
  
  mounted() {
    this.getCurrentUser();
  },
  
  created() {
    this.$bindAsArray ("invoiceHistory", this.$root.$firebaseRefs.invoiceHistory.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("firms", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray ("firmList", this.$root.$firebaseRefs.firm.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("buyerById", this.$root.$firebaseRefs.buyer.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsObject("sellerById", this.$root.$firebaseRefs.seller.orderByChild('brand').equalTo(this.selectedBrand)),
    this.$bindAsArray ("deposit", this.$root.$firebaseRefs.customerDeposit.orderByChild('brand').equalTo(this.selectedBrand));
    this.$bindAsArray ("customerPayments", this.$root.$firebaseRefs.customerPayments.orderByChild('brand').equalTo(this.selectedBrand))
    // let today = new Date()
    // this.toDate = `${today.getFullYear()}-${today.getMonth()+1}-${today.getDate()}`
  },
  data() {
    return {
      invoiceHeader: [
        { text: "View Invoice", value: "" },
        { text: "Date", value: "date", sortable:true, sort: (a, b) => console.log(a) },
        // { text: "Invoice - Key", value: "Name" },
        // { text: "Firm Name", value: "Village" },
        { text: "Invoice No", value: "Block" },
        { text: "Debit", value: "Block" },
        { text: "Credit", value: "Block" },
        { text: "Running Balance", value: "Block" },
        { text: "Payment Type", value: "Identity Number" },
        { text: "Vocher type", value: "Vocher type" }
      ],
      dialog: false,
      isUserBuyer: null,
      selectedInvoice: {},
      selectedFirm: null,
      toDate: null,
      fromDate: null,
      datepickerFrom: null,
      datepickerTo: null,
      filteredInvoice : [],
      payments : [],
      customerPayments : [],
      prevRunningBal : 0,
      currentUser: {},
      voucherTypeFilter : [],
      total : {
        credit : 0,
        debit : 0,
        RunningBal : 0 
      },
      invoiceProductListHeader: [
        { text: "Name", value: "Name" },
        { text: "HSN code", value: "HSN" },
        { text: "Taxable rate", value: "Taxable" },
        { text: "Unit", value: "Unit" },
        { text: "Quantity", value: "quantity" },
        { text: "Fat", value: "quantity" },
        { text: "Rate", value: "rate" }
      ]
    };
  },
  computed: {
    ...mapGlobalGetters(["selectedBrand","brandFinYear"]),
    ...mapBuyerGetters(["selectedBuyer",]),
    ...mapGlobalGetters({
      gState: 'state',
    }),
    invoiceList() {
      this.total = {
        credit : 0,
        debit : 0,
        RunningBal : 0, 
        date : 'Total'
      }
      this.getCurrentUser()

      // let filteredInvoice = this.invoices.filter(
      //   item =>
      //     item["brand"] === this.selectedBrand &&
      //     item["buyerId"] === this.$route.params.customerId
      // );
      this.filteredInvoice =[];
      this.payments = [];
      this.customerDeposit = [];

      let toDate = this.toDate ?  new Date(this.toDate).getTime() : null;
      let fromDate = this.fromDate ? new Date(this.fromDate).getTime() : null;

      this.filteredInvoice = this.invoiceHistory.filter(item =>
          item["brand"] === this.selectedBrand &&
          item["buyerId"] === this.$route.params.customerId && 
          (!!this.selectedFirm ? item["firm"] === this.selectedFirm['.key'] : true) && 
          (item.deleted != true) &&
          // (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)
          (item['returnStatus'] ? (item['returnStatus'] == 'remaining' && item['status'] =='paid') :true)
          && (item['isLatest'] != undefined ? item['isLatest'] == true : true)
      );
      if(!this.payments.length) {
         this.payments  = this.customerPayments.filter(
        item =>
          item["brand"] === this.selectedBrand &&
          (!!this.selectedFirm ? item["firm"] === this.selectedFirm['.key'] : true) && 
          item["buyerId"] === this.$route.params.customerId &&
          (Number.parseFloat(item["remainingAmount"]) > 0)

      );
      }

       if(!this.customerDeposit.length) {
         this.customerDeposit  = this.deposit.filter(
        item =>
          item["brand"] === this.selectedBrand &&
          (!!this.selectedFirm ? item["firm"] === this.selectedFirm['.key'] : true) && 
          item["buyerId"] === this.$route.params.customerId &&
          (item["type"] === "Advance" || item["type"] === "Opening Balance" || item["type"] === "LoanTaken" || item["type"] === "LoanGiven" || item["type"] === "Security")
      );
      }
      this.filteredInvoice.map((item, index) => { 
        //if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        if(item.newlyCreated && (item.status === "paid" || item.status === "partial")) {
        let newItem = JSON.parse(JSON.stringify(item));
          newItem.date = newItem.date-1;
          newItem.transactionType = "Debit";
          newItem.paidAmount = 0;
          newItem.status = 'due';
          newItem.remainingAmount = newItem.totalAmount;
          delete newItem['newlyCreated'];
          newItem['.key'] = new Date().getTime();
          this.filteredInvoice.push(newItem);
        }
        if(item.closedDate) {
          this.filteredInvoice[index].date = item.closedDate
        }
      });

      this.customerDeposit.map((deposit,index)=>{
        this.filteredInvoice.push(deposit)
        if((deposit["type"] === "LoanTaken" || deposit["type"] === "LoanGiven") && deposit.status =="paid" && !deposit.loanTransaction) {
          this.customerDeposit[index].status = 'due';
        }
      })

      this.payments.map((pay)=>{
        pay['type'] = 'CustomerPayment'
        this.filteredInvoice.push(pay)
      })
 //     this.filteredInvoice = this.customerDeposit.concat(this.filteredInvoice);

      this.filteredInvoice.map((item,index)=>{
        this.filteredInvoice[index]['voucherType'] = this.getVocherType(item);
      })
      if(this.voucherTypeFilter.length) {
        this.filteredInvoice = this.filteredInvoice.filter(it => this.voucherTypeFilter.indexOf(it['voucherType']) > -1);
      }

      this.filteredInvoice.sort(function(a,b){
        return -(new Date(b.date) - new Date(a.date));
      });


      this.filteredInvoice.map((item, index) => {
        if (item["items"] && item["items"].length)
          this.filteredInvoice[index][
            "GST_Percentage_total"
          ] = getGSTPercentageTotal(item["items"]);
        else {
          this.filteredInvoice[index]["GST_Percentage_total"] = {
            GST_3: 0,
            GST_5: 0,
            GST_12: 0,
            GST_18: 0,
            GST_28: 0
          };
        }
        // if(this.filteredInvoice[index]['.key'] == "-M1dKDXv7immzLNuRDZA") {
        //   console.log(JSON.stringify(this.filteredInvoice[index],null,4))
        // }
        this.filteredInvoice[index]["customer"] =
          this.buyerById[item.buyerId] || this.sellerById[item.buyerId] || {};
        this.filteredInvoice[index]["debit"] = this.getDebit(this.filteredInvoice[index]);
        this.filteredInvoice[index]["credit"] = this.getCredit(
          this.filteredInvoice[index]
        );
        if(this.isUserBuyer) {
          let temp = this.filteredInvoice[index]["credit"];
          this.filteredInvoice[index]["credit"] = this.filteredInvoice[index]["debit"];
          this.filteredInvoice[index]["debit"] = temp;
        }
        this.filteredInvoice[index]["RunningBal"] =
          Number.parseFloat(this.filteredInvoice[index]["debit"] || 0) -
           Number.parseFloat(this.filteredInvoice[index]["credit"] || 0) +
          (index == 0 ? 0 :  Number.parseFloat(this.filteredInvoice[index - 1]["RunningBal"]));
        this.total.debit += Number.parseFloat(this.filteredInvoice[index]["debit"]);
        this.total.credit += Number.parseFloat(this.filteredInvoice[index]["credit"]);
        // this.total.RunningBal += Number.parseFloat(this.filteredInvoice[index]["RunningBal"]);
        this.total.RunningBal += Number.parseFloat(Number.parseFloat(this.filteredInvoice[index]["debit"]) - Number.parseFloat(this.filteredInvoice[index]["credit"])) ;
      });
     
      this.prevRunningBal = 0;
      let actualFiltered = [...this.filteredInvoice.filter((item=> (fromDate ? item.date >= fromDate : true) && (toDate ? item.date <= toDate : true)))]

      this.filteredInvoice.map((inv,index)=>{
        if(actualFiltered.length &&  inv['.key'] == actualFiltered[0]['.key'] && index > 0) {
          this.prevRunningBal = this.filteredInvoice[index-1]["RunningBal"];
        }
      });
      this.total = {
        credit : 0,
        debit : 0,
        RunningBal : 0 ,
        date : 'Total'
      }
      actualFiltered.map((invoice,index)=>{
       this.total.debit += Number.parseFloat(actualFiltered[index]["debit"]);
        this.total.credit += Number.parseFloat(actualFiltered[index]["credit"]);
        // this.total.RunningBal += Number.parseFloat(this.filteredInvoice[index]["RunningBal"]);
        this.total.RunningBal += Number.parseFloat(Number.parseFloat(actualFiltered[index]["debit"]) - Number.parseFloat(actualFiltered[index]["credit"])) ;
        })
      this.selectedInvoice = actualFiltered[0];
      return actualFiltered;
    },
    firmsByBrand1() {
      return this.firmList.filter(item => item["brand"] === this.selectedBrand);
    },
    // current brands firm list
    firmsByBrand () {
        // return selected brand firms
        let firmsB = this.firmList
          .filter((item) => item['brand'] === this.selectedBrand)
          firmsB.map((item) => {
            if (item.defaultFirm) {
              this.selectedFirm = item;
            }
          })
        return firmsB;
    },
  },
  methods: {
      removeMinus (value) {
      if(value == 0 ) {
        return 0;
      }
      value = value.toString()
      if(value.charAt(0) == '-') {
        return value.slice(1)
      }
    },
    print(){
      let firm = this.selectedFirm || {name:'-'};
      firm.address = this.selectedFirm ? this.generateAddress(this.selectedFirm) : '-';
      let customer = this.currentUser;
      customer.address = this.generateAddress(customer);
      let invoices = [...this.invoiceList];
      invoices.push(this.total);
      let doc = buyerStatement({
        firm : firm,
        customer : customer,
        // invoices : this.filteredInvoice,
        invoices : invoices,
        toDate : this.toDate ?  new Date(this.toDate).getTime() : null,
        fromDate : this.fromDate ? new Date(this.fromDate).getTime() : null
      });
      pdfMake.createPdf(doc).download();
    },
    printDetailed(){
      let firm = this.selectedFirm || {name:'-'};
      firm.address = this.selectedFirm ? this.generateAddress(this.selectedFirm) : '-';
      let customer = this.currentUser;
      customer.address = this.generateAddress(customer);
      let invoices = [...this.invoiceList];
      invoices.push(this.total);
      let doc = buyerStatementDetailed({
        firm : firm,
        customer : customer,
        // invoices : this.filteredInvoice,
        invoices : invoices,
        toDate : this.toDate ?  new Date(this.toDate).getTime() : null,
        fromDate : this.fromDate ? new Date(this.fromDate).getTime() : null
      });
      pdfMake.createPdf(doc).download(this.customer);
    },
    exportXLS(){
      let firm = this.selectedFirm;
      firm.address = this.generateAddress(firm);
      let wb = buyerStatementExcel({selectedFirm : firm,invoices :this.filteredInvoice })
      XLSX.writeFile(wb, 'Statements_'+new Date().getTime()+'.xlsx') 
    // name of the file is 'book.xlsx'
    },
    generateAddress(user) {
      let address = "";
      if (user.block) {
        address = `${user.block}`;
      }
      if (user.village) {
        address = `${address ? address + " - " : ""}${user.village}`;
      }
      if (user.tehsil) {
        address = `${address ? address + " - " : ""}${user.tehsil}`;
      }
      if (user.state) {
        address = `${address ? address + " - " : ""}${user.state}`;
      }
      return address;
    },
    getVocherType(invoice) {
      if(invoice.type == 'CustomerPayment') {
        if (invoice.isBuyer) {
          return "Receipt";
        } else {
          return "Payment";
        }
      }
      if (invoice.return) {
        if (invoice.isBuyer) {
          return "Credit Note";
        } else {
          return "Debit Note";
        }
      } 
      else if (invoice.transactionType != "Debit" && invoice["type"] === "Advance" || invoice["type"] === "Opening Balance" || invoice["type"] === "LoanGiven" || invoice["type"] === "LoanTaken" || invoice["type"] === "Security") {
        // debugger
        // if((invoice["type"] === "LoanTaken" || invoice["type"] === "LoanGiven") && invoice.status =="paid") {
        if((invoice["type"] === "LoanTaken" || invoice["type"] === "LoanGiven" || invoice["type"] === "Opening Balance" ) && invoice.status =="paid") {
        return (invoice["type"] +" (paid)");
         } else {
            return invoice["type"] ;
         }
      } 
      // else if (invoice.isBuyer && invoice.status === "due") {
      //   return "Sale";
      // }
      // else if (invoice.isBuyer && invoice.status === "paid" || "partial") {
      //   return "Receipt";
      // }
      // else if (!invoice.isBuyer && invoice.status === "due") {
      //   return "Purchase";
      // }
      // else if (!invoice.isBuyer && invoice.status === "paid" || "partial") {
      //   return "Payment";
      // } 
      else if (invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Sale";
      }
      else if ((invoice.isBuyer && invoice.transactionType === "Credit") || (invoice.isBuyer && invoice.transactionType === "Partial Paid")) {
        return "Receipt";
      }
      else if (!invoice.isBuyer && invoice.transactionType === "Debit") {
        return "Purchase";
      }
      else if ((!invoice.isBuyer && invoice.transactionType === "Credit") || (!invoice.isBuyer && invoice.transactionType === "Partial Paid")) {
        return "Payment";
      }

    },
    openProd(invoice) {
      this.selectedInvoice = invoice;
      this.dialog = true;
    },
    getFirmName(firmId) {
      if (this.firms && this.firms[firmId]) {
        return this.firms[firmId]["name"];
      }
      return "--";
    },
    getCurrentUser() {
      let buyer = this.buyerById[this.selectedBuyer];
      let seller = this.sellerById[this.selectedBuyer];
      this.isUserBuyer = buyer ? true : false;
      this.currentUser =
        this.isUserBuyer ? buyer : seller;
    },
    getGSTtotal(item) {
      let GSTTotal = 0;
      item &&
        item.items &&
        item.items.map(item => {
          GSTTotal += Number.parseFloat(item.GSTValue);
        });
      return GSTTotal;
    },
    getDebit(item) {
      if(item.type =='CustomerPayment') {
        if (!item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      }
      else if(['LoanTaken','LoanGiven','Opening Balance','Advance','Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken' : {
            if(item.loanTransaction) {
              return 0;
            } else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case 'LoanGiven' : {
            if(item.loanTransaction) {
              if(item.loanPaymentType == 'interest') {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            }
            else {
              return 0 ;
            }
            break;
          }
          case 'Opening Balance' : {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case 'Advance' : {
            return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            break;
          }
          case 'Security' : {
            return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
            break;
          }
        }
      } else {
         switch(item.status) {
              case 'due' : {
                  return 0;
                  break;
              }
              case 'paid' : {
                  // return (Number.parseFloat(item['totalAmount']));
                  return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                  break;
              }
              case 'partial' : {
                  return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
                  break;
              }
          }
      }

      // if(item.status == 'due' || item.status == 'partial') {
      //   if(item.type === "LoanTaken" && (item.status == 'due' || item.status == 'partial' )) {
      //     return Number.parseFloat(item.amount);
      //   } else if(item.type === "LoanTaken") {
      //     return 0 ;
      //   } else if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   }
      // } else if(item.type === "LoanGiven" && item.status == 'paid') {
      //   return Number.parseFloat(item.amount) + Number.parseFloat(item.paidAmount);
      // } else if(item.type === "LoanTaken" && item.status == 'paid') {
      //   return 0;
      // } else if(item.status) {
      //   return (Number.parseFloat(item['amountFromBank']) + Number.parseFloat(item['amountFromCash']));
      // } else {
      //   if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   }
      //   else if(item.type == "Advance" || item.type == "Security") {          
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } 
      //   else {
      //     return 0;
      //   }
      // }
    },
    getCredit(item) {
      if(item.type =='CustomerPayment') {
        if (item.isBuyer) {
          return 0;
        } else {
          return item['remainingAmount'];
        }
      }
        else if(['LoanTaken','LoanGiven','Opening Balance','Advance','Security'].includes(item.type)) {
        switch (item.type) {
          case 'LoanTaken' : {
            if(item.loanTransaction) {
              if(item.loanPaymentType == 'interest') {
                return Number.parseFloat(item.paidInterest);
              } else {
                return Number.parseFloat(item.paidAmount);
              }
            } else {
              return 0;
            }
            break;
          }
          case 'LoanGiven' : {
            if(item.loanTransaction) {
              return 0;
            }
            else {
              return Number.parseFloat(item.amount);
            }
            break;
          }
          case 'Opening Balance' : {
              // return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
                return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);

            break;
          }
          case 'Advance' : {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
          case 'Security' : {
            return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
            break;
          }
        }
      } else {
          switch(item.status) {
                case 'due' : {
                    return item.totalAmount;
                    break;
                }
                case 'paid' : {
                    return 0;
                    break;
                }
                case 'partial' : {
                    return 0;
                    break;
                }
            }
      }

      // if(item.status == 'due' || item.status == 'partial') {
      //   if(item.type === "LoanGiven" && (item.status == 'due' || item.status == 'partial' )) {
      //     return Number.parseFloat(item.amount);
      //   } else if(item.type === "LoanGiven") {
      //     return 0 ;
      //   } else if (item.type == "Opening Balance") {
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } else {
      //     return item["remainingAmount"];
      //   }
      // } else if(item.type === "LoanTaken" && item.status == 'paid') {
      //   return Number.parseFloat(item.amount) + Number.parseFloat(item.paidAmount);
      // } else if(item.status) {
      //   return 0;
      // }  else {
      //   if (item.type == "Opening Balance"){
      //     return item.isUserCreated ? Number.parseFloat(item.amount) : Number.parseFloat(0);
      //   } 
      //   else if(item.type == "Advance" || item.type == "Security") {
      //     return item.isUserCreated ? Number.parseFloat(0) : Number.parseFloat(item.settledAmount);
      //   } 
      //   else {
      //     return 0;
      //   }
      // }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/components/Buyers/Buyer/BuyerStatements.vue